import styled, { css } from 'styled-components';
export const Wrapper = styled.div `
  position: relative;
`;
export const SwiperWrapper = styled.div `
  overflow: hidden;
  background-color: white;
  
  ${({ theme: { sessionsWrapper } }) => sessionsWrapper};
  
  &:after {
    content: "";
    ${({ theme: { sessionsWrapperAfter } }) => sessionsWrapperAfter};
  }

  ${({ theme: { layout } }) => (layout === 'vertical') && css `
    margin-right: -2rem;
  `};
  
  .swiper-slide {
    max-width: 8rem;
    //padding: 0 1rem;
    margin-right: 1.5rem;
    
    ${({ theme: { sessionSlide } }) => sessionSlide};

    &:first-child {
      margin-left: 1rem;
      ${({ theme: { sessionSlideFirst } }) => sessionSlideFirst};
    }
    
    &:last-child {
      margin-right: 0
    }

    &:last-child {
      margin-right: 6rem !important;
    }
  }
`;
export const ErrorWrapper = styled.div `
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
  margin-bottom: 4rem;
  
  // a bit hacky, but required because otherwise it overhangs the chevrons for the session swiper, tried doing none hacky ways
  // but couldn't get working within the timeframe, should be 1.5rem margin top after this
  & + & {
    margin-top: -2.5rem;
  }
`;
export const SwiperNavigation = styled.div `
  ${({ theme: { sessionNavigationWrapper } }) => sessionNavigationWrapper};
`;
const SwiperNavigationButton = css `
  border: none;
  padding: 0;
  margin: 0;
  background-color: transparent;
  cursor: pointer;
  ${({ theme: { sessionNavigationButton } }) => sessionNavigationButton};
  
  &::after {
    ${({ theme: { sessionNavigationButtonIcon } }) => sessionNavigationButtonIcon};
  }
`;
export const SwiperNext = styled.button `
  ${SwiperNavigationButton};
`;
export const SwiperPrev = styled.button `
  ${SwiperNavigationButton};

  &::after {
    transform: scale(-1);
  }
`;
export const ListWrapper = styled.div `
  width: 100%;
`;
export const List = styled.ul `
  list-style: none;
  padding: 0;
  margin: 0;
  display: flex;
  flex-direction: column;
  gap: 0.8rem;
`;
export const ListItem = styled.li `
  margin: 0;
`;
export default {
    Wrapper,
    SwiperWrapper,
    SwiperNavigation,
    SwiperNext,
    SwiperPrev,
    ListWrapper,
    List,
    ListItem,
};
